<template>
    <div class="zzc" v-if="istouxiangcard" @click="gbuserinfo">
      <div class="gr" @click.stop>
        <div class="avatarName">
         <div class="NameLeft">
           <el-avatar :size="42" :src="isuserInfo.avatar">
            <img src="@/assets/components/morentx.png" />
          </el-avatar>

          <div class="Namenameid">
              <div>{{isuserInfo.username}}</div>
              <div class="ididididididiidid">ID:{{isuserInfo.uid}}</div>
          </div>
         </div>

          <div class="NameRight" @click="qiehuan">
               <span>切换账号</span>
               <img src="@/assets/components/usercardpop/youjiantou.png" alt="">
          </div>
        </div>


        <!-- 是不是会员 -->
        <div class="sbshy" @click="lijikaitong">
          <!-- 不是会员 -->
          <div class="bushivip" v-if="!isuserInfo.isVip" >
            <div>您还不是会员</div>
            <div class="enh">
              <span>购买</span>
               <img src="@/assets/components/usercardpop/gnmyoujiantou.png" alt="">
            </div>
          </div>

          <!-- 是会员 -->
          <div class="shivip" v-else>
              <div class="shivipleft">
                <div style="margin-right:10px">会员：</div>
                <div>{{isuserInfo.order.payment_time.match(/(\d{4}-\d{2}-\d{2})/)[0]}}</div>
                <div>——</div>
                <div>{{computeVipTime}}</div>
              </div>
              <div class="enh">
              <span>购买</span>
               <img src="@/assets/components/usercardpop/gnmyoujiantou.png" alt="">
            </div>
          </div>

        </div>

        <!-- <div class="card">
          <div class="novip" v-if="!isuserInfo.isVip">
            <div class="kaitVip" @click="lijikaitong"></div>
          </div>
          <div class="yvip" v-else>
            <div class="yvipBtn" @click="lijikaitong"></div>
            <div class="daoqi">到期时间：{{ computeVipTime }}</div>
          </div>
        </div> -->

          <!-- <div class="sige">
                <img src="@/assets/components/usercardpop/gerensige.jpg" alt="">
          </div> -->

          <div class="jies">
            <div class="twohx"></div>
            <div class="text">解锁会员 享权益</div>
            <div class="twohx"></div>
          </div>




        <!-- <div class="bottomTwoItem" @click="grzx">
          <img src="@/assets/components/usercardpop/user.png" alt="" />
          <span>个人中心</span>
        </div> -->
        <!-- <div class="bottomTwoItem i1" @click="chzl">
          <img src="@/assets/components/usercardpop/ziliao.png" alt="" />
          <span>查看资料</span>
        </div>
        <div class="bottomTwoItem i1" @click="xzjilu('记录')">
          <img src="@/assets/components/usercardpop/xiazai.png" alt="" />
          <span>下载记录</span>
        </div> -->
        <!-- <div class="bottomTwoItem i1" @click="gotogr('/message/follow',2)">
          <img src="@/assets/components/usercardpop/guanzhu.png" alt="" />
          <span>我的关注</span>
        </div> -->
        <!-- <div class="bottomTwoItem i1" @click="xzjilu('收藏')">
          <img src="@/assets/components/usercardpop/shoucang.png" alt="" />
          <span>我的收藏</span>
        </div> -->
        <!-- <div class="bottomTwoItem i1" @click="gotogr('/message/like',4)">
          <img src="@/assets/components/usercardpop/xihuan.png" alt="" />
          <span>我的喜欢</span>
        </div> -->

        <div class="tuichudenglu" @click="logoutBtn">
          <!-- <img src="@/assets/components/usercardpop/logout.png" alt="" /> -->
          <span>退出登录</span>
        </div>
      </div>
    </div>



</template>

<script>
import {mapMutations ,mapActions,mapGetters} from 'vuex'
import assist from '@/utils/commonality'
export default {
  mixins: [],
  components: {},
  props: {
   value: {
    type: Boolean,
    default: false,
  },

  },
  data () {
    return {
      infocard:true,//是否显示
    }
  },
  computed: {
 ...mapGetters([
      "isuserInfo",
      'istouxiangcard'
    ]),
        computeVipTime() {
      if (this.isuserInfo?.order?.vip_time > 4092595200) {
        return "永久会员";
      }
      // 获取并检查时间戳
      const vipTimestamp = Number(this.isuserInfo.vip_time); // 确保是数字类型

      // 转换时间戳为毫秒
      const date = new Date(vipTimestamp * 1000); // 乘以 1000 以转换为毫秒

      // 获取年份
      const year = date.getFullYear();

      // 获取月份，注意月份从 0 开始，所以需要加 1
      const month = String(date.getMonth() + 1).padStart(2, "0");

      // 获取日期
      const day = String(date.getDate()).padStart(2, "0");

      // 返回格式化后的日期
      return `${year}.${month}.${day}`;
    },
  },
  watch: {
  },
  created () {},
  mounted () {
    
     console.log(this.isuserInfo);
  },
  methods: {
   
    
     ...mapActions(["logout"]),
    ...mapMutations(['updatispopvip','updategrzx']),
   gbuserinfo() {
      //用户个人信息卡片关闭
      // this.infocard = false;
      this.$store.commit('updatetouxiangcard',false)
      
    },
        grzx() {
      //点击个人信息的个人中心
      this.$store.commit('updategrzx',true)
      // this.infocard = false;
      this.$store.commit('updatetouxiangcard',false)
    },
    async logoutBtn() {
      //退出登录
      await this.logout();
       //  本次项目的
       this.$store.commit('updatetouxiangcard',false)
       this.$tips('退出成功')
      // window.location.reload();
    },
    lijikaitong() {
      this.$store.commit('updatetouxiangcard',false)
      this.updatispopvip(true)
    },
    chzl() { //查看资料
      this.$store.commit('updatetouxiangcard',false)
      this.$store.commit('updategrzx',true)
    },
   xzjilu(type) { //下载记录
   if(type === '记录') {
      this.$router.push('/record?which=1')
   }else if(type==='收藏') {
     this.$router.push('/record?which=2')
   }
  this.$store.commit('updatetouxiangcard',false)
   },

  async qiehuan() {
     await this.logout();
       //  本次项目的
       this.$store.commit('updatetouxiangcard',false)
      this.$store.commit('updateloginVisible',true)
   }

  }
}
</script>

<style scoped lang="scss">
.zzc {
  position: fixed;
  top: 0;
  left: 0;
  min-width: 1200px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  z-index: 99999999999;
}
.gr {
  position: absolute;
  right: 140px;
  top: 10%;
  width: 354px;
  background-color: #fff;
  border-radius: 18px;
  z-index: 999999;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  padding: 25px;
  display: flex;
  flex-direction: column;
  
  .sbshy {
    cursor: pointer;
    width: 100%;
    height: 50px;
    background: url('@/assets/components/usercardpop/shibushihuiyuanbg.png') no-repeat;
    background-size: 100% 100%;
    margin-top: 15px;

    .bushivip {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      padding: 0 15px;
      font-size: 14px;
      .enh {
        display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 12px;
            margin-left: 8px;
          }
      }
    }

    .shivip {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      font-size: 12px;
      padding: 0 15px;
      .shivipleft {
        display: flex;
        align-items: center;
      }

    .enh {
        display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 12px;
            margin-left: 8px;
          }
      }
    }
  }


  .card {
    .novip,
    .yvip {
      position: relative;
      width: 189px;
      height: 60px;
      margin-top: 15px;
    }
    .novip {
      background: url("@/assets/components/usercardpop/novip.png") no-repeat;
      background-size: 100% 100%;
      .kaitVip {
        cursor: pointer;
        position: absolute;
        top: 50%;
        right: 5%;
        transform: translateY(-50%);
        width: 62px;
        height: 26px;
        background: url("@/assets/components/usercardpop/kaitong.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .yvip {
      background: url("@/assets/components/usercardpop/yvip.png") no-repeat;
      background-size: 100% 100%;
      .yvipBtn {
        cursor: pointer;
        position: absolute;
        top: 50%;
        right: 5%;
        transform: translateY(-50%);
        width: 62px;
        height: 26px;
        background: url("@/assets/components/usercardpop/xufei.png") no-repeat;
        background-size: 100% 100%;
      }
      .daoqi {
        position: absolute;
        bottom: 20%;
        left: 6%;
        font-size: 10px;
        color: #ffffff;
      }
    }
  }
  .avatarName {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .NameLeft {
      display: flex;
      align-items: center;
      justify-content: center;

      .Namenameid {
        margin-left: 10px;
        .ididididididiidid {
          font-size: 12px;
          margin-top: 5px;
        }
      }
    }

    .NameRight {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #666666;
      img {
        margin-left: 6px;
        width: 12px;
        margin-top: 2px;
      }
    }
  }

  .bottomTwoItem {
    cursor: pointer;
    margin-top: 15px;
    img {
      margin-right: 20px;
      width: 32px;
      height: 32px;
    }
    display: flex;
    align-items: center;
  }
    .i1 {
    img {
      margin-left: 3px;
      margin-right: 25px;
      width: 25px;
      height: 25px; 
    }
  }
} 

.sige {
  width: 100%;
  margin-top: 30px;
  img {
    width: 100%;
  }
}

.tuichudenglu {
  cursor: pointer;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  color: #fff;
  margin-top: 20px;
  border-radius: 10px;
}

.jies {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;

  .text {
    margin: 0 20px;
    font-size: 14px;
  }
  
  .twohx {
    flex: 1;
    height: 2px;
    background-color: #d6d6d6;
  }
}
</style>
